import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  files: []
};
const filesSlice = createSlice({
  name: 'files',
  initialState,
  reducers: {
    addFiles: (state, action) => {
      state.files = state.files.concat(action.payload.files);
    },
    addFilesFromApi: (state, action) => {
      state.files = state.files.concat(action.payload.files);
    },
    updateFileProgress: (state, action) => {
      // TODO: See about isolating this logic to the shared input component
      const {
        uniqueId,
        progress
      } = action.payload;
      state.files = state.files.map(file => file.uniqueId === uniqueId ? Object.assign({}, file, {
        progress
      }) : file);
    },
    updateFileManagerMetadata: (state, action) => {
      const {
        uniqueId,
        fileManagerId,
        url,
        name
      } = action.payload;
      state.files = state.files.map(file => file.uniqueId === uniqueId ? Object.assign({}, file, {
        fileManagerId,
        url,
        name
      }) : file);
    },
    updateFileStatus: (state, action) => {
      const {
        uniqueId,
        status
      } = action.payload;
      state.files = state.files.map(file => file.uniqueId === uniqueId ? Object.assign({}, file, {
        status
      }) : file);
    },
    removeFiles: (state, action) => {
      state.files = state.files.filter(file => file.fileManagerId !== undefined && !action.payload.fileManagerIds.includes(file.fileManagerId));
    },
    clearFiles: state => {
      state.files = [];
    }
  }
});
export const fileActions = filesSlice.actions;
export default filesSlice.reducer;